import React from 'react';

/**
 * Renders a partner logo — either the real image (if `logo` provided) or a
 * clean text-based fallback tile so the page never looks empty while assets
 * are being sourced.
 */
const IntegrationLogo = ({ partner, size = 'md' }) => {
  const sizes = {
    sm: 'h-10 px-4 text-sm',
    md: 'h-14 px-6 text-base',
    lg: 'h-20 px-8 text-lg',
  };
  const box = sizes[size] || sizes.md;
  const tall = partner.showName ? 'min-h-[6.5rem]' : '';

  const content = partner.logo ? (
    partner.showName ? (
      <div className="flex flex-col items-center justify-center gap-1.5 h-full py-3">
        <img
          src={partner.logo}
          alt={partner.name}
          loading="lazy"
          className="h-12 max-w-full w-auto object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
        />
        <span
          className="text-[10px] font-semibold text-gray-400 group-hover:text-[#00BCE4] uppercase tracking-wider whitespace-nowrap transition-colors duration-300"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {partner.name}
        </span>
      </div>
    ) : (
      <img
        src={partner.logo}
        alt={partner.name}
        loading="lazy"
        className="max-h-full max-w-full w-auto object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
      />
    )
  ) : (
    <span
      className="font-bold text-gray-500 group-hover:text-[#00BCE4] transition-colors duration-300 whitespace-nowrap"
      style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' }}
    >
      {partner.name}
    </span>
  );

  const inner = (
    <div
      className={`group flex items-center justify-center bg-white border border-gray-100 rounded-2xl ${box} ${tall} hover:border-[#00BCE4]/40 hover:shadow-lg hover:-translate-y-1 transition-all duration-500`}
    >
      {content}
    </div>
  );

  if (partner.url) {
    return (
      <a href={partner.url} target="_blank" rel="noopener noreferrer" aria-label={partner.name}>
        {inner}
      </a>
    );
  }
  return inner;
};

export default IntegrationLogo;
